import { ChatRow, ChatType, EntityType } from "namirasoft-expert";

export class ExpertRoutes
{
    static Home: string = "/";
    // Agent
    static AgentList: string = "/agent/list";
    static AgentNew: string = "/agent/new";
    static AgentView(id: string)
    {
        return `/agent/${id}/view`;
    }
    static AgentEdit(id: string)
    {
        return `/agent/${id}/edit`;
    }
    static AgentCopy(id: string)
    {
        return `/agent/${id}/copy`;
    }
    // Agent Test
    static AgentTest(id: string, entity_type: EntityType)
    {
        return `/agent/${id}/test/${entity_type}`;
    }
    // Chat
    static ChatPage(chat: ChatRow)
    {
        if (chat.type === ChatType.Agent)
            return ExpertRoutes.Chat_AgentContinue(chat.agent_id, chat.id);
        if (chat.type === ChatType.Test)
            return ExpertRoutes.Chat_Test(chat.agent_id, chat.id);
        return ExpertRoutes.Chat_AgentNew(chat.agent_id);
    }
    static Chat(agent_id: string, chat_id: string, chat_type: string)
    {
        return `/agent/${agent_id}/chat/${chat_id}/${chat_type}`;
    }
    static Chat_AgentNew(agent_id: string)
    {
        return ExpertRoutes.Chat_AgentContinue(agent_id, "new");
    }
    static Chat_AgentContinue(agent_id: string, chat_id: string)
    {
        return ExpertRoutes.Chat(agent_id, chat_id, ExpertRoutes.Chat_Relative.Agent());
    }
    static Chat_Description(agent_id: string, chat_id: string)
    {
        return ExpertRoutes.Chat(agent_id, chat_id, ExpertRoutes.Chat_Relative.Description());
    }
    static Chat_Role(agent_id: string, chat_id: string)
    {
        return ExpertRoutes.Chat(agent_id, chat_id, ExpertRoutes.Chat_Relative.Role());
    }
    static Chat_RoleAssignment(agent_id: string, chat_id: string)
    {
        return ExpertRoutes.Chat(agent_id, chat_id, ExpertRoutes.Chat_Relative.RoleAssignment());
    }
    static Chat_Test(agent_id: string, chat_id: string)
    {
        return ExpertRoutes.Chat(agent_id, chat_id, ExpertRoutes.Chat_Relative.Test());
    }
    static Chat_Relative = {
        Agent: () =>
        {
            return `agent`;
        },
        Description: () =>
        {
            return `description`;
        },
        Role: () =>
        {
            return `role`;
        },
        RoleAssignment: () =>
        {
            return `role-assignment`;
        },
        Test: () =>
        {
            return `test`;
        },
    }
}